import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Image404 from "../../assets/svg/404.svg";
import { PrimaryButton, SecondaryButton } from "./ButtonComp";
import { RiArrowLeftLine } from "react-icons/ri";

const Page404 = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {/* <Header /> */}
      <div className="flexCenter flex-column">
        <img src={Image404} alt="Image404" className="image404" />
        <div className="title404 mt-4">Oops, looks like page not found!</div>
        <div className="description404 mt-3">
          We can't seem to find the page you're looking for.
        </div>
        <div className="d-flex justify-content-center gap-2 my-4">
          <SecondaryButton
            onClick={() => navigate(-1)}
            buttonName="Go Back"
            icon={<RiArrowLeftLine size={18} />}
          />
          <PrimaryButton
            onClick={() => navigate("/")}
            buttonName="Go to Dashboard"
          />
        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default Page404;
